import { render, staticRenderFns } from "./subFeeInfo.vue?vue&type=template&id=4c342286"
import script from "./subFeeInfo.vue?vue&type=script&lang=ts"
export * from "./subFeeInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports